import React from "react";
import NextImage from "../common/NextImage";
import { getImageUrl } from "../../utils/generalLiveCenter";

const PreMatches = ({ data, sport = "tennis" }) => {
  // Get player image URL - use teamImage utility if headersList is provide

  return (
    <div className="lineupbox">
      <div className="global_table player_lineup_t">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Players</th>
              <th>Rank</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="players_inf">
                  <div className="avtar">
                    <NextImage
                      src={getImageUrl('', '', 'tennis', data?.commentary?.competitors?.hpid)}
                      height={18}
                      width={18}
                      alt="homePlayer"
                      priority={false}
                    />
                  </div>
                  <div className="avtar_inf">
                    <strong className="name small">
                      {data?.player?.[0]?.nm}
                    </strong>
                  </div>
                </div>
              </td>
              <td>
                <ul className="prev_match_status">
                  {data?.player?.[0]?.pre_matches?.map((w, i) => (
                    <li key={w + i} className={`${w === "W" ? "win" : "loss"}`}>
                      {w}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <strong className="count_num">
                  {data?.player?.[0]?.rank || "-"}
                </strong>
              </td>
            </tr>
            <tr>
              <td>
                <div className="players_inf">
                  <div className="avtar">
                    <NextImage
                      src={getImageUrl('', '', 'tennis', data?.commentary?.competitors?.apid)}
                      height={18}
                      width={18}
                      alt="awayPlayer"
                      priority={false}
                    />
                  </div>
                  <div className="avtar_inf">
                    <strong className="name small">
                      {data?.player?.[1]?.nm}
                    </strong>
                  </div>
                </div>
              </td>
              <td>
                <ul className="prev_match_status">
                  {data?.player?.[1]?.pre_matches?.map((w, i) => (
                    <li key={w + i} className={`${w === "W" ? "win" : "loss"}`}>
                      {w}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <strong className="count_num">
                  {data?.player?.[1]?.rank || "-"}
                </strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreMatches;
